<template>
  <div class="intelligentAgriculture-page digitalpigraising">
    <!-- 数字乡村-->
    <div class="haeder-container blackStatic">
      <Header></Header>
      <Nav></Nav>
    </div>
    	<div class="main">
            <div class="top-banner">
                <img style="width:100%;height:auto" src="../../assets/img/caseDetails/digitalpigraising/banner.png">            
            </div>
            <div class="mid-body"  style="background:#F6F7FA;margin-bottom: 0;padding-top: 40px;">
                <div class="mid-body-box">
                    <h2 style="text-align: left;margin-bottom: -15px;margin-top: 40px;font-size: 38px;font-weight: 500;">百倍云智慧养殖方案</h2>

                    <div>
                        <div class="left-box" style="position: relative;">
                            <div class="top-right"></div>
                            <div class="bottom-left"></div>
                            <img style="width:100%;height:auto;position:relative" src="../../assets/img/caseDetails/digitalpigraising/index01.png">    
                         </div>
                        <div class="left-box" style="margin-top: 29px;">
                            <p style="margin-bottom: 20px;font-size: 24px;font-weight: 700;margin-top: 8px;">方案背景</p>
                            <p style="    font-size: 16px;
    letter-spacing: 2px;
    color: #666;
    line-height: 24px;">我国是一个世界养殖大国，养殖业在整个畜牧业中占有主导地位，养殖业已成为我国经济中十分重要的支柱产业之一。 据统计，中国养殖业的产业化、规模化较低，年出栏量500头以上规模养殖场出栏比 不到一半，普通人吃到的一半肉类来自年出栏量500以下的散养农户啊、小型养殖 场。然而，传统的养殖方式不仅生产效率低，而且污染治理、疾病防控及食品安全 等方面存在较大问题。。</p>
                        </div>
                    </div>
                </div>    
            </div> 

            <div class="mid-body"  style="background:#fff;margin-bottom: 0;padding-top: 40px;">
                <div class="mid-body-box">
                    <h2 style="text-align: center;margin-bottom: 45px;margin-top: 110px;font-size: 32px;font-weight: 500;">传统养殖弊端</h2>
                    <div>
                        <div class="left-cbox">
                            <img style="width:50%;height:auto;float:left" src="../../assets/img/caseDetails/digitalpigraising/box1.png"> 
                            <div class="right-box">
                                <h3>基础设施薄弱</h3>
                                <p>生产设施设备落后，饲养管理粗放， 养殖环境差，标准化养殖比量低</p>    
                            </div>   
                         </div>
                        <div class="left-cbox">
                            <img style="width:50%;height:auto;float:left" src="../../assets/img/caseDetails/digitalpigraising/box2.png"> 
                            <div class="right-box">
                                <h3>生产成本过高</h3>
                                <p>玉米作为主要的饲料用量呈现刚性需求，其增量远高于国内粮食预期增量，导致价格不断攀升</p>    
                            </div>   
                         </div>
                         <div class="left-cbox">
                            <img style="width:50%;height:auto;float:left" src="../../assets/img/caseDetails/digitalpigraising/box3.png"> 
                            <div class="right-box">
                                <h3>疫情来势凶猛</h3>
                                <p>由于标准化生产水平不高，环境污染加剧，饲养管理不善，抗生素加剧了病毒变异速度，使动物的抗病力量下 降</p>    
                            </div>   
                         </div>
                         <div class="left-cbox">
                            <img style="width:50%;height:auto;float:left" src="../../assets/img/caseDetails/digitalpigraising/box4.png"> 
                            <div class="right-box">
                                <h3>环保压力增大</h3>
                                <p>政府正在积极推行限养和禁养政策， 环保问题已关系到养殖业能否在某些 地区继续生存</p>    
                            </div>   
                         </div>
                    </div>
                </div>    
            </div> 
            <div class="mid-body" style="position:relative;height:625px">
                
                <img style="width:100%;height:auto;" src="../../assets/img/caseDetails/digitalpigraising/index05.png">    
                <div class="mid-body-box" style="position: absolute;top: 40px;left: 50%;margin-left: -600px;">    
                    <h2 style="text-align: center;margin-bottom: 70px;margin-top: 60px;font-size: 32px;font-weight: 500;">百倍云智慧养殖</h2>  
                    <div>          
                        <img style="width:100%;height:auto;">                                   
                         <div class="three-box" style="padding: 10px 25px;"> 
                            <img style="width:80px;height:auto;margin: auto;margin-top: 47px" src="../../assets/img/caseDetails/digitalpigraising/lbox1.png">    
                            <p style="margin-bottom: 20px;font-size: 18px;font-weight: 700;margin-top: 36px; text-align:center">智慧养殖系统环境监控</p>
                            <p style="font-size: 16px;letter-spacing: 1px;color:#666;text-align:left;line-height: 25px;">养殖场环境与动物的成长息息相关，环境质量变差会导致动物的发育不良甚至爆发疫病。智慧养殖系统将养殖场的温度、湿度、空气质量等环境变量统一监控并通过物联网采集器实时传输在客户端（APP、PC、演示大屏）中集中呈现让养殖场的环境情况透明化</p>
                        </div>    
                        <div class="three-box" style="padding: 10px 25px;"> 
                            <img style="width:80px;height:auto;margin: auto;margin-top: 47px" src="../../assets/img/caseDetails/digitalpigraising/lbox2.png">    
                            <p style="margin-bottom: 20px;font-size: 18px;font-weight: 700;margin-top: 36px;text-align:center">预警、设备控制智能化</p>
                            <p style="font-size: 16px;letter-spacing: 1px;color:#666;text-align:left;line-height: 25px;">对于监控中的环境变量，当其达到预设危险值时通过现场声光、电话、微信等通讯告警方式告知养殖户。并对警报信息进行处理，可通过预设设备自动控制来减少日常工作量。如风机的启动、水帘的控制，喂料器的启动，实现智慧养殖。</p>
                        </div>  
                        <div class="three-box" style="padding: 10px 25px;"> 
                            <img style="width:80px;height:auto;margin: auto;margin-top: 47px" src="../../assets/img/caseDetails/digitalpigraising/lbox3.png">    
                            <p style="margin-bottom: 20px;font-size: 18px;font-weight: 700;margin-top: 36px;text-align:center">数据采集、趋势分析</p>
                            <p style="font-size: 16px;letter-spacing: 1px;color:#666;text-align:left;line-height: 25px;">通过调节养殖场所各个数据参数，提供给动物最佳生长环境，在一定程度上减少生病情况，提升肉类质量，有效调节生长速率，带给养殖户更多的收益</p>
                        </div>
                              
                    </div>
                </div>    
            </div> 
          <div class="mid-body" style="background:rgba(246,247,250,1);margin-bottom: 0;padding-top: 30px;padding-bottom: 60px;">
                <div class="mid-body-box">
                    <h2 style="text-align: center;margin-bottom: 30px;margin-top: 40px;font-size: 32px;font-weight: 500;">智慧养殖环境监测系统</h2>
                    <div>   
                        <p style="margin-bottom: 40px;font-size: 16px;font-weight: 500;margin-top: 36px;color:#666;text-align:left;line-height:32px">养殖环境与动物的成长息息相关，环境质量变差会导致动物的发育不良甚至爆发疫病，百倍云智慧养殖运用数据采集设备通过NB-IOT或4G网络传输的方式，定时将采集的数 据发送到云平台最终完成数据采集目的，云平台根据采集的数据信息及参数指标区间范围进行核实，一旦数据不达标，立即启动预警机制，将信息通知养殖户或监管人员 最终由养殖户通过远程设备控制的方式，调节智能设备，改善养殖环境。</p>                                                                       
                        <img style="width:100%;height:auto;" src="../../assets/img/caseDetails/digitalpigraising/index02.png">                                             
                    </div>
                </div>    
            </div> 
             <div class="mid-body" style="background:#fff;margin-bottom: 0;padding-top: 30px;padding-bottom: 60px;">
                <div class="mid-body-box">
                    <h2 style="text-align: center;margin-bottom: 30px;margin-top: 40px;font-size: 32px;font-weight: 500;">智慧养殖全产业链数据化</h2>
                    <div>   
                        <p style="margin-bottom: 40px;font-size: 16px;font-weight: 500;margin-top: 36px;color:#666;text-align:left;line-height:32px">随着养殖产业生产过程线上化、产业交易电商化、金融服务标准化、经营管理智能化，完整的产业数据积累便可形成。依托云计算，运用积累的产业大数据，进行决策分 析，为养殖户提供实时、精准的生产过程指导、操作预警提醒，可实现远程化管理，让养殖全程可预警和提醒。</p>                                                                       
                        <img style="width:100%;height:auto;" src="../../assets/img/caseDetails/digitalpigraising/index03.png">                                             
                    </div>
                </div>    
            </div> 
            <div class="mid-body" style="background:rgba(246,247,250,1);margin-bottom: 0;padding-top: 30px;padding-bottom: 60px;">
                <div class="mid-body-box">
                    <h2 style="text-align: center;margin-bottom: 30px;margin-top: 40px;font-size: 32px;font-weight: 500;">养殖场BIM三维可视化</h2>
                    <div>   
                        <p style="margin-bottom: 40px;font-size: 16px;font-weight: 500;margin-top: 36px;color:#666;text-align:left;line-height:32px">养殖场全方位BIM可视化管理，借助颜色、标牌、表格、挂图等一系列视觉工具，形成员工对动物群生产能共同理解的语言，进而提高部门员工的协调和工作效率，预警、发现 和追溯养殖场生产中存在的问题。</p>                                                                       
                        <img style="width:100%;height:auto;" src="../../assets/img/caseDetails/digitalpigraising/index04.png">                                             
                    </div>
                </div>    
            </div> 
            <div class="mid-body" style="background:#fff;margin-bottom: 0;padding-top: 30px;padding-bottom: 60px;">
                <div class="mid-body-box">
                    <h2 style="text-align: center;margin-bottom: 30px;margin-top: 40px;font-size: 32px;font-weight: 500;">相关硬件展示</h2>
                    <div>   
                        <p style="margin-bottom: 40px;font-size: 16px;font-weight: 500;margin-top: 36px;color:#666;text-align:center;line-height:32px">百倍云推出智慧养殖主流传感器，涵盖先进的AI计算盒，养殖场环境监测，自动投喂，监控测重，防丢失功能等传感器，更多产品请联系我们。</p>                                                                       
                        <div class="fourbox">
                            <p>导轨巡视机器人</p>
                            <img style="height:auto;" src="../../assets/img/caseDetails/digitalpigraising/cp1.png">   
                        </div>
                        <div class="fourbox">
                            <p>智能控制柜</p>
                            <img style="height:auto;" src="../../assets/img/caseDetails/digitalpigraising/cp2.png">   
                        </div>                                            
                        <div class="fourbox">
                            <p>AI计算盒</p>
                            <img style="height:auto;" src="../../assets/img/caseDetails/digitalpigraising/cp3.png">   
                        </div>  
                        <div class="fourbox">
                            <p>过道称重称</p>
                            <img style="height:auto;" src="../../assets/img/caseDetails/digitalpigraising/cp4.png">   
                        </div>  
                        <div class="fourbox">
                            <p>NB温湿度传感器</p>
                            <img style="height:auto;" src="../../assets/img/caseDetails/digitalpigraising/cp5.png">   
                        </div>  
                        <div class="fourbox">
                            <p>动物标签读卡器</p>
                            <img style="height:auto;" src="../../assets/img/caseDetails/digitalpigraising/cp6.png">   
                        </div>  
                        <div class="fourbox">
                            <p>通孔电子耳标</p>
                            <img style="height:auto;" src="../../assets/img/caseDetails/digitalpigraising/cp7.png">   
                        </div>  
                        <div class="fourbox">
                            <p>可视化耳标</p>
                            <img style="height:auto;" src="../../assets/img/caseDetails/digitalpigraising/cp8.png">   
                        </div>  
                    </div>
                </div>    
            </div>           
		</div>
    <Foot></Foot>
  </div>
</template>
<script>
import Header from '@/components/Header'
import Nav from '@/components/Nav'
import Foot from '@/components/Foot'  

export default {
  name: 'intelligentAgriculture',
  components:{
    Header,
    Nav,
    Foot
  },
  data(){
    return {
        select:1,
    }
  },
  mounted() {
  },
  methods: {
      clicknav(e){
          this.select = e
      }
  }
}
</script>
<style>
    .digitalpigraising .banner-title{
        width: 490px;
        height: 120px;
        position: absolute;
        top: 50%;
        right: 50%;
        margin-top: 40px;
    }
    .digitalpigraising .mid-body{
        margin-bottom: 120px;
    }
    .digitalpigraising .mid-body-box{
        width: 1200px;
        margin: auto;
        position: relative;
    }
    .digitalpigraising .four-box{
        width: 25%;
        float: left;
        text-align: center;
        box-sizing: border-box;
        padding: 30px;
        box-sizing: border-box;
    }
    .digitalpigraising .list-box{
     box-sizing: border-box;
    padding: 20px;
    position: relative;
    text-align: left;
    padding-left: 240px;
        
    }
    .digitalpigraising .list-box img{
        width: 24px;
        height: auto;
        position: absolute;
        left: 190px;
        top: 21px;
    }
    .digitalpigraising .list-box p{
        margin-bottom: 14px;
    }
    .digitalpigraising .five-box{
        width: 20%;
        float: left;
        text-align: center;
        box-sizing: border-box;
        padding: 30px;
        box-sizing: border-box;
        padding-bottom: 0;
    }
     .digitalpigraising .five-box img{
            width: 50px;
    height: auto;
    margin: auto;
    cursor: pointer;
    }
        .digitalpigraising .five-box span{
         display: inline-block;
        padding-top: 22px;
        padding-bottom: 32px;
        font-size: 18px;
        font-weight: bold;
        color: #8993a7;
        line-height: 1em;
        border-bottom: 3px solid transparent;
        cursor: pointer;
    }
   
    .digitalpigraising .three-box{
        width: 30%;
        float: left;
        text-align: center;
        box-sizing: border-box;
        padding: 30px;
        box-sizing: border-box;
        background: #fff;
        height: 430px;
        margin: 1.6%;
    }
    .digitalpigraising .left-box{
        width: 50%;
        float: left;
        text-align: left;
        box-sizing: border-box;
        padding: 74px;
    }c

    .digitalpigraising .nav-box{
        width: 100%;
        border: 1px solid #dbe0e5;
        box-sizing: border-box;
        padding: 40px;
    }
    .digitalpigraising .nav-box .list{
        width: 100%;
        margin-bottom: 20px;
        text-align: left;
    }
   .digitalpigraising .list-item{
        padding: 12px 20px;
        color: #8993a7;
        margin-right: 20px;
        margin-bottom: 20px;
        display: inline-block;
        background: #ffffff;
        border: 1px solid #d0d7e1;
        -webkit-box-shadow: 0px 3px 7px 0px rgba(189, 230, 202, 0.35);
        box-shadow: 0px 3px 7px 0px rgba(189, 230, 202, 0.35);
        min-width: 120px;
        text-align: center;
        position: relative;
            font-size: 12px;
    width: 150px;
    }
    .digitalpigraising .img_index03{
        width:223px;
        height:auto;
        position:absolute;
        right: 405px;
        top: 97px;
        z-index: 2;
    }

   .digitalpigraising .img_index04{
        width: auto;
        height: 94%;
        position: absolute;
        top: 0;
        right: 65%;
        margin-top: 1%;
    }
      .digitalpigraising .img_index06{
        width:223px;
        height:auto;
        position:absolute;
        right: 205px;
        top: 97px;
        z-index: 2;
    }
    .digitalpigraising .img_index07{
    width: 223px;
    height: auto;
    position: absolute;
    left: 165px;
    top: 229px;
    z-index: 2;
    }
   .digitalpigraising .img_index09{
        width:223px;
        height:auto;
        position:absolute;
        right: 205px;
        top: -205px;
        z-index: 2;
    }
    .digitalpigraising .active{
        border-bottom: 3px solid #f8a811 !important;
        color: #333 !important;
    }
        .digitalpigraising .left-cbox{
        width: 50%;
        float: left;
        text-align: left;
        box-sizing: border-box;
        padding: 34px;
    }
    .digitalpigraising .right-box{
        float: left;
        width: 50%;
            padding: 25px;
    background: #FFFFFF;
    box-shadow: 0px 0px 31px 1px rgba(14, 5, 10, 0.04);
    height: 248px;
       
    }
    .digitalpigraising .right-box  h3{
            height: auto;
            font-size: 20px;
            text-align: left;
            padding: 0;
            font-weight: 700;
            line-height: 47px;
            width: 100%;
            margin-bottom: 20px;
        }
        .digitalpigraising .fourbox{
            float: left;
            width: 21%;
            margin: 2%;
            background: #fff;
            border: 1px solid #1AB334;
            box-sizing: border-box;
            padding: 10px;
            height: 220px;
        }
        .digitalpigraising .fourbox img {
            margin: auto;
        }
        .digitalpigraising .fourbox p {
            margin: 20px 0;
        }
        .digitalpigraising .top-right{
            right: 63px;
    width: 120px;
    height: 120px;
    background: #0EBE2C;
    position: absolute;
    top: 94px;
        }
       .digitalpigraising .bottom-left{
                left: 81px;
    width: 120px;
    height: 120px;
    background: #0EBE2C;
    position: absolute;
    top: 274px;
        }
</style>